import React from 'react';
import heroImage from '../../assets/images/hero-bg.jpg';
import './Hero.css';

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div 
        className="hero__background"
        style={{ backgroundImage: `url(${heroImage})` }}
      ></div>
      <div className="container">
        <div className="hero__content">
          <h1 className="hero__title">Кассовые чеки в Челябинске</h1>
          <h2 className="hero__subtitle">Официальные чеки с QR кодом / 100% подтверждение</h2>
          <div className="hero__buttons">
            <a href="#contact" className="btn btn-primary hero__btn">от гостиницы</a>
            <a href="#contact" className="btn btn-secondary hero__btn">от строймага</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;